module.exports = __webpack_public_path__ + "img/kita.a0e0ac28.svg";